export default (config, shop) => {

    if (!config.callbackUrl) {
        return false;
    }

    if (config.callbackUrl && config.sortCode1 && shop.isDisabled) {
        return 'wrong-code';
    }
    
    if (config.callbackUrl && config.sortCode1 && config.sortCode1 === shop.sortCode1) {
        return true;
    }

    if (config.callbackUrl) {
        return true;
    }
};
